// All action times

const registration = {
  REQUEST_DETAILS: 'REQUEST_DETAILS',
  RECEIVE_DETAILS: 'RECEIVE_DETAILS',
  REQUEST_REGISTRATON: 'REQUEST_REGISTRATON',
  RECEIVE_REGISTRATON: 'RECEIVE_REGISTRATON'
}

export default registration



// WEBPACK FOOTER //
// ./src/routes/Registration/actions/actionTypes.js